<template>
  <div class="container">
    <header class="header-static">
      <a
        :href="model.CloseButtonUrl"
        data-mfp-src="#customerSupportModal"
        class="close-button open-modal"
        ><span class="icon icon-close"
      /></a>
    </header>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import CheckoutContentModel from '../interfaces/CheckoutContentModel';

export default defineComponent({
  name: 'ProposalHeaderView',
  props: {
    model: {
      type: Object as PropType<CheckoutContentModel>,
      default() {
        return null;
      }
    }
  }
});
</script>
